import React from 'react';
import TrendArrow from './TrendArrow';
import { fmtLatency } from '../lib/duration';

// Format the metric value to match its suffix's expected precision so the
// card body and the TrendArrow delta render with the same number of decimals
// (e.g., "12568ms" pairs with "-300ms", not "12568ms" + "-300.0ms").
// The 'latency' suffix returns a unit-included string (e.g., "9.6s" or
// "750ms") — see fmtLatency. The MetricCard / TrendArrow renderers detect
// that and skip the trailing suffix concatenation so the unit isn't doubled.
function formatMetric(value, suffix) {
  if (value == null) return '—';
  if (suffix === 'latency') return fmtLatency(value);
  const n = Number(value);
  if (!Number.isFinite(n)) return String(value);
  if (suffix === 'ms') return Math.round(n).toString();
  return value;
}

export default function MetricCard({ label, value, suffix = '', prevValue, tint, hint, loading }) {
  const renderedSuffix = suffix === 'latency' ? '' : suffix;
  return (
    <div
      className={`rounded-xl border border-gray-200 dark:border-gray-800 p-4 ${tint || 'bg-white dark:bg-gray-900'}`}
    >
      <div className="text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide">{label}</div>
      <div className="mt-1 text-2xl font-bold text-gray-900 dark:text-white">
        {loading ? '—' : (value == null ? '—' : `${formatMetric(value, suffix)}${renderedSuffix}`)}
      </div>
      <div className="mt-1 flex items-center gap-2">
        {prevValue !== undefined && (
          <TrendArrow current={Number(value)} previous={Number(prevValue)} suffix={suffix} />
        )}
        {hint && <span className="text-xs text-gray-500 dark:text-gray-400">{hint}</span>}
      </div>
    </div>
  );
}
